var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.27 23.207A1.27 1.27 0 0 1 0 21.937V1.477C0 .774.568.206 1.27.206h20.46c.702 0 1.27.568 1.27 1.27v20.46a1.27 1.27 0 0 1-1.27 1.27h-5.86V14.3h2.99l.447-3.471H15.87V8.613c0-1.005.279-1.69 1.72-1.69h1.838V3.817a24.57 24.57 0 0 0-2.678-.137c-2.65 0-4.465 1.617-4.465 4.588v2.56H9.288V14.3h2.997v8.907H1.269z","fill":"currentColor"}));
}

Facebook.defaultProps = {"viewBox":"0 0 28 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
